<template>
  <div>
    <div v-if="items.length != 0">
      <div class="orders">
        <h6 class="text-center tracking-widest uppercase subtitle text-gray">
          últimos pedidos
        </h6>
        <h2 class="text-center orders__label text-orange py-4">
          pedir novamente
        </h2>

        <ul class="orders__list flex flex-wrap">
          <li class="half-width flex-1 block" v-for="item in items" :key="item.id">
            <div class="orders__list-header">
              <div class="orders__list-header-group">
                <h4>{{ item.date }}</h4>
                <p>{{ item.label_address }} - {{ item.price }}€</p>
              </div>

              <div class="w-2/5 orders__list-actions">

                <div class="mb-2 sm:hidden md:block" v-if="!item.has_review">
                  <order-rating-modal :order="item" />
                </div>

                <div>
                  <button
                    class="btn btn--outlined btn-action sm:hidden md:block"
                    @click="reorder(item.id)"
                  >
                    Reencomendar
                  </button>
                </div>

              </div>
            </div>

            <div class="orders__list-footer">
              <ul>
                <li
                  v-for="listItem in item.choices"
                  :key="listItem.product_name"
                >
                  <h5 class="text-orange">
                    {{ listItem.qty }} x {{ listItem.product_name }}
                  </h5>
                </li>
              </ul>
            </div>

            <button
              class="btn btn--outlined btn--full md:hidden"
              @click="reorder(item.id)"
            >
              Reencomendar
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      required: true,
    },
  },
  methods: {
    reorder(id) {
      location = `/reorder/${id}`;
    },
  },
};
</script>
